import { render, staticRenderFns } from "./BancoCasos.vue?vue&type=template&id=59183fa9"
import script from "./BancoCasos.vue?vue&type=script&lang=js"
export * from "./BancoCasos.vue?vue&type=script&lang=js"
import style0 from "./BancoCasos.vue?vue&type=style&index=0&id=59183fa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports